<div class="parent-box">
  <mat-toolbar class="title-bar">My Jobs</mat-toolbar>

  <div class="jobs-grid-parent">
    <job-management-grid></job-management-grid>
  </div>
</div>
